import React, { useEffect, useState } from "react";
import { AppBar, Box, Button, Toolbar, Typography, Switch} from "@mui/material";
import { LightMode, Nightlight } from "@mui/icons-material";
import { Link } from "react-router-dom";
import UserAuthNavBarCompomemt from "./UserAuthNavBarCompomemt";
import NavbarButton from "./NavbarButton";
import '../i18n';
import { useTranslation } from 'react-i18next';
import SwitchLocal from "./SwitchLocal";
import { useUser } from "../context/UserContext"

export default function MainNavbar({changeMode, mode}) {
    const [access, setAccess] = useState(null);
    const [t, i18n] = useTranslation();
    const Light = {background: '#05336e', left: '0', width: '100%'}
    const Dark = {background: 'black', left: '0', width: '100%'}
    const userContext = useUser();
    
    useEffect(() => {
        setAccess({
            "isAdmin": userContext.isAdmin(), 
            "routes": userContext.get_routes()
        });
    }, [setAccess, userContext]);
    
    return (
        <AppBar position="sticky" style={mode == 'dark' ? Dark : Light}>
            <Toolbar style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', minWidth: 0 }}>
                    <Box>
                       <Typography
                            style={{ color: 'white', fontWeight: 'bold' }}
                            component={Link}
                            to="/"
                        >
                            Proctoring
                        </Typography> 
                    </Box>
                    <Button
                        component={Link}
                        to="/"
                        style={{ color: 'white', fontWeight: 'normal' }}
                    >
                        {t('Главная')}
                    </Button>
                    <NavbarButton access = {access} path="/mypage">
                        {t("Личный кабинет")}
                    </NavbarButton>
                    <NavbarButton access={access} path="/generateSession">
                        {t("Для студентов")}
                    </NavbarButton>
                    <NavbarButton access={access} path="/generateRoom">
                        {t("Ссылка на экзамен")}
                    </NavbarButton>
                    {access?.isAdmin && <Button component={Link} to="/admin/plugin-settings" style={{ color: 'white' }}>Настройки плагина</Button>}
                    {/*
                    <NavbarButton access={access} path="/lessonList">
                        {t("Список предметов")}
                    </NavbarButton>
                    */}
                    <NavbarButton access={access} path="/table">
                        {t("Таблица")}
                    </NavbarButton>
                    <NavbarButton access = {access} path="/logTable">
                        {t("Логи")}
                    </NavbarButton>
                    {/*
                    <NavbarButton access={access} path="/instruction">
                        {t("Инструкция")}
                    </NavbarButton>
                    <Button
                        component={Link}
                        to="/faq"
                        style={{ color: 'white', fontWeight: 'normal' }}
                    >
                        FAQ
                    </Button>
                    */}
                </Box>
                <Box style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                    <LightMode />
                    <Switch color="default" 
                        checked={mode == 'dark'}
                        onChange={changeMode}
                    />
                    <Nightlight />
                </Box>
                <Box style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                    <SwitchLocal/>
                    <UserAuthNavBarCompomemt />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
